import React, { useState, useEffect } from "react";
import { getTopRecipes, getLatestRecipes } from "../api";
import { Link } from "react-router-dom";
import { Button, TextField } from "@mui/material";

const API_BASE_URL = "https://pwa-backend.fenrir-tech.fr"; // Replace with your API URL

const HomePage = () => {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("top"); // Default filter is "Top"
  const [searchQuery, setSearchQuery] = useState(""); // Search query state

  useEffect(() => {
    const fetchRecipes = async () => {
      setLoading(true);
      setError(null);
      try {
        const data =
          filter === "top" ? await getTopRecipes() : await getLatestRecipes();
        setRecipes(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRecipes();
  }, [filter]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) {
      setError("Veuillez entrer un terme de recherche.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${API_BASE_URL}/recipts/search?query=${encodeURIComponent(
          searchQuery
        )}`
      );
      if (!response.ok) {
        throw new Error("Erreur lors de la recherche des recettes.");
      }
      const data = await response.json();
      setRecipes(data);
    } catch (err) {
      console.error("Search error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-container">
      <h1 style={{ fontSize: "3rem" }}>Bienvenue sur le Petit Cuisinier </h1>

      {/* Search Bar */}
      <div style={{ display: "flex", width: "100%" }}>
        <form
          onSubmit={handleSearch}
          className="search-bar"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width: "50%",
            margin: "0 25%",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="Rechercher une recette..."
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              flexGrow: 1, // Makes the TextField take available space
              "& .MuiInputBase-root": {
                height: "50px", // Adjust the height of the input
              },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              height: "50px", // Make the button match the height of the TextField
              padding: "0 20px", // Adjust padding for better button size
              textTransform: "none", // Avoids uppercase transformation by default
              "&:hover": {
                backgroundColor: "#1976d2", // Custom hover color if needed
              },
            }}
          >
            Rechercher
          </Button>
        </form>
      </div>

      <div
        className="filter-buttons"
        style={{
          display: "flex",
          gap: "3%",
          marginBottom: "20px",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Button
          variant={filter === "top" ? "contained" : "outlined"}
          color="primary"
          onClick={() => setFilter("top")}
          sx={{
            height: "50px",
            width: "150px", // Adjust button width if needed
            textTransform: "none", // Keep text case as is
            fontWeight: filter === "top" ? "bold" : "normal",
            "&:hover": {
              backgroundColor: filter === "top" ? "#1976d2" : "#e3f2fd", // Custom hover for active state
            },
          }}
        >
          Top Recettes
        </Button>

        <Button
          variant={filter === "new" ? "contained" : "outlined"}
          color="secondary"
          onClick={() => {
            console.log(filter);
            setFilter("new");
          }}
          sx={{
            width: "150px", // Adjust button width if needed
            textTransform: "none", // Keep text case as is
            fontWeight: filter === "new" ? "bold" : "normal",
            "&:hover": {
              backgroundColor: filter === "new" ? "#1976d2" : "#fce4ec", // Custom hover for active state
            },
            height: "50px",
          }}
        >
          Nouvelles Recettes
        </Button>
      </div>

      {loading && <p>Chargement des recettes...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className="recipes-list">
        {Array.isArray(recipes) && recipes.length > 0 ? (
          recipes.map((recipe) => (
            <div key={recipe.id} className="recipe-card">
              <h3>{recipe.name}</h3>
              <img
                src={recipe.image} // Utilise directement l'image encodée en base64
                alt={recipe.name}
                style={{
                  maxWidth: "100%",
                  height: "250px",
                  objectFit: "contain",
                }}
              />
              <p style={{ marginTop: "20px", fontSize: "1rem" }}>
                <strong> Description : </strong>
                <span style={{ fontStyle: "italic" }}>
                  {" "}
                  {recipe.description}{" "}
                </span>
              </p>
              <p>
                <strong>Likes :</strong> {recipe.likeCount}
              </p>
              <Button
                component={Link}
                to={`/recipes/${recipe.id}`}
                variant="contained"
                color="primary"
              >
                Voir plus
              </Button>
            </div>
          ))
        ) : (
          <p>Aucune recette trouvée.</p>
        )}
      </div>
    </div>
  );
};

export default HomePage;
